import React from 'react';
import PropTypes from 'prop-types';
import { Grid, GridColumn } from 'semantic-ui-react';
import Image from '../../../../atoms/Image';
import SocialMedia from '../../../../molecules/SocialMedia';
import InternalLink from '../../../../atoms/InternalLink';
import OutboundLink from '../../../../atoms/OutboundLink';
import Copyright from '../../../../molecules/CopyrightLabel';

const ServicesFooter = props => {
  const { bottomColor, pages, pagesClassName, socialMedia, copyright, logo } = props;

  const PagesSection = () => {
    return pages[0].pages.map(pagesItem => (
      <Grid.Column
        key={`footer-service-${pagesItem.pageTitle}`}
        computer={1}
        mobile={16}
        tablet={1}
        centered
        textAlign="center"
        className={pagesClassName}
      >
        {pagesItem.internal ? (
          <InternalLink to={pagesItem.slug} label={pagesItem.pageTitle} />
        ) : (
          <OutboundLink to={pagesItem.slug} label={pagesItem.pageTitle} />
        )}
      </Grid.Column>
    ));
  };

  const spaceComputerColumns = 16 - pages[0].pages.length - 2;
  const spaceTableColumns = 16 - pages[0].pages.length - 2;

  return (
    <div
      style={{
        backgroundColor: bottomColor,
        textAlign: 'center',
        paddingTop: '2em',
        paddingBottom: '2em',
      }}
    >
      <Grid style={{ paddingBottom: '2em' }} centered>
        <Grid.Column computer={1} tablet={1} only="computer tablet" />
        <PagesSection />
        <GridColumn
          only="computer"
          computer={spaceComputerColumns}
          tablet={spaceTableColumns}
          textAlign="right"
        >
          <SocialMedia socialMediaValues={socialMedia} buttonType="rect" />
        </GridColumn>
        <GridColumn only="mobile" mobile={16} textAlign="center">
          <SocialMedia socialMediaValues={socialMedia} buttonType="rect" />
        </GridColumn>
        <GridColumn computer={1} tablet={1} only="tablet" />
      </Grid>
      <Copyright company={copyright.company} phrase={copyright.phrase} />
      <Image src={logo} centered size="small" style={{ paddingTop: '.9em' }} />
    </div>
  );
};

ServicesFooter.propTypes = {
  bottomColor: PropTypes.string.isRequired,
  pagesClassName: PropTypes.string,
  logo: PropTypes.string.isRequired,
};
ServicesFooter.defaultProps = {
  pagesClassName: 'footer-pages',
};

export default ServicesFooter;
